import { makeAutoObservable } from "mobx"

type Column = {
  editable?: boolean,
  active?: () => boolean
}

class TableStore {

  selectedCell: [ number, string ] | null = null
  isEdit = false
  menuOpen = false

  constructor() {
    makeAutoObservable(this)
  }

  setSelectedCell(index: number, key: string, column: Column = {}) {
    if (column.editable === false) return
    if (this.selectedCell && this.selectedCell[0] === index && this.selectedCell[1] === key) return
    this.isEdit = true
    this.selectedCell = [ index, key ]
    this.setMenuOpen(false)
    requestAnimationFrame(() => {
      this.setMenuOpen(true)
    })
  }

  resetSelectedCell() {
    this.selectedCell = null
  }

  getKey(index: number) {
    if (!this.selectedCell || this.selectedCell[0] !== index) return
    return this.selectedCell[1]
  }

  startEdit() {
    this.isEdit = true
  }

  setMenuOpen(menuOpen: boolean) {
    this.menuOpen = menuOpen
  }

}

export default TableStore